import { render, staticRenderFns } from "./hqglCarRegInsuranceFeeDetail.vue?vue&type=template&id=44b770b4&scoped=true&"
import script from "./hqglCarRegInsuranceFeeDetail.vue?vue&type=script&lang=js&"
export * from "./hqglCarRegInsuranceFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglCarRegInsuranceFeeDetail.vue?vue&type=style&index=0&id=44b770b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b770b4",
  null
  
)

export default component.exports